<!-- Heading -->
<mdb-card class="wow fadeIn">

    <!--Card content-->
    <mdb-card-body class="d-sm-flex justify-content-between">
        <div *ngIf="!busy" style="display: contents;">
            <h4 class="mb-sm-0">
                <span>Welcome {{settingsService.userProfile.displayName}}, let's take a look at your trades!{{extraInfo}}</span>
            </h4>
            <!-- <form class="d-flex md-form justify-content-center my-0">
                <button mdbBtn color="trakly" size="sm" class="my-0 p">
                    
                    Request a Trade
                </button>

            </form> -->
        </div>

        <!--Loading display-->
        <app-loading [busy]="busy"></app-loading>
    </mdb-card-body>

</mdb-card>
<!-- Heading -->


<app-stats-card [transactionDataBundle]="statCardsTransactionDataBundle" [totalPinBalance]="totalPinBalance" [fiaAvailable]="statCardsFiaAvailable"
    [sdaAvailable]="statCardsSdaAvailable" [busy]="statCardsBusy"></app-stats-card>


<!--Grid row-->
<div class="row wow fadeIn mt-5">
    <!--Grid column-->
    <div class="col-md-12 mb-4">
        <!--Card-->
        <mdb-card>
            <!-- Card header -->
            <!-- <div class="card-header">{{currentYear}} YTD Summary</div> -->

            <!--Card content-->
            <mdb-card-body>
                <div class="my-2" *ngIf="!yearlySummaryBusy && traded">
                    <div class="d-block" style="height: 40vh;">
                        <canvas mdbChart [chartType]="chart1Type" [datasets]="chartDatasets" [labels]="chartLabels"
                            [colors]="chartColors" [options]="chartOptions" [legend]="false" >
                        </canvas>
                    </div>

                </div>
                <div class="w-100 text-center" *ngIf="!yearlySummaryBusy && !traded">
                    <img src="../../../../assets/img/FileSearch.svg" class="col-sm-2 mx-auto d-block" alt="1">
                    <h2 class="text-center">Looks like you haven't traded yet...</h2>
                    <p>Once you've done your first trade, we'll show your monthly profit summary here.</p>
                </div>
                <!--Loading display-->
                <app-loading [busy]="yearlySummaryBusy"></app-loading>
            </mdb-card-body>
        </mdb-card>
        <!--/.Card-->
    </div>
    <!--Grid column-->
</div>
<!--Grid row-->

<!-- <app-stats-card2></app-stats-card2> -->